import { CreateExcessMoneyRefundReduxState, ExcessMoneyRefundReducerDispatch, ExcessMoneyRefundTypes } from "./types";

const CREATE_EXCESS_MONEY_REFUND_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}
const CreateExcessMoneyRefundReducer = (state: CreateExcessMoneyRefundReduxState = CREATE_EXCESS_MONEY_REFUND_INIT_STATE, action: ExcessMoneyRefundReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND: {
            return {
                ...state,
                loading: true
            }
        }
        case ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.RESET_CREATE_MONEY_REFUND: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

const ApproveExcessMoneyRefundReducer = (state: CreateExcessMoneyRefundReduxState = CREATE_EXCESS_MONEY_REFUND_INIT_STATE, action: ExcessMoneyRefundReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE: {
            return {
                ...state,
                loading: true
            }
        }
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.RESET_APPROVE_MONEY_REFUND: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

const RejectExcessMoneyRefundReducer = (state: CreateExcessMoneyRefundReduxState = CREATE_EXCESS_MONEY_REFUND_INIT_STATE, action: ExcessMoneyRefundReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT: {
            return {
                ...state,
                loading: true
            }
        }
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ExcessMoneyRefundTypes.RESET_REJECT_MONEY_REFUND: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

export { CreateExcessMoneyRefundReducer, ApproveExcessMoneyRefundReducer, RejectExcessMoneyRefundReducer }